import * as _ from 'lodash';

import { IImageDto, imageDto } from 'src/assets/common/models/image-dto.g';
import { IImageForm } from './image-form';
import { ILevelGeneralData, levelGeneralData } from 'src/app/infrastructure/models/level-general-data';

export const imageData = {
    ... levelGeneralData,
    guid: 'guid',
    fileName: 'fileName',
    extension: 'extension',
    description: 'description',
    contentType: 'contentType',
    folderShardPath: 'folderShardPath',
    height: 'height',
    width: 'width',
    modifiedOn: 'modifiedOn',
    inactive: 'inactive',
    deleted: 'deleted',
    fileVariantType: 'fileVariantType',
} as const;

export type TImageData = (typeof imageData)[keyof typeof imageData];

export interface IImageData extends ILevelGeneralData {
    [imageData.guid]: string;
    [imageData.fileName]: string | null;
    [imageData.extension]: string | null;
    [imageData.description]: string | null;
    [imageData.contentType]: string | null;
    [imageData.folderShardPath]: string | null;
    [imageData.height]: number | null;
    [imageData.width]: number | null;
    [imageData.modifiedOn]: string | null;
    [imageData.inactive]: boolean;
    [imageData.deleted]: boolean;
    [imageData.fileVariantType]: string | null;
}

export class ImageData
    implements IImageData
{
    [imageData.guid]!: string;
    [imageData.fileName]: string | null = null;
    [imageData.extension]: string | null = null;
    [imageData.description]: string | null = null;
    [imageData.contentType]: string | null = null;
    [imageData.folderShardPath]: string | null = null;
    [imageData.height]: number | null = null;
    [imageData.width]: number | null = null;
    [imageData.modifiedOn]: string | null = null;
    [imageData.inactive]!: boolean;
    [imageData.deleted]!: boolean;
    [imageData.fileVariantType]: string | null = null;


    protected constructor(modelDto?: IImageDto | null);
    protected constructor(modelData: IImageData, modelForm: IImageForm);
    protected constructor(value?: IImageDto | IImageData | null, modelForm?: IImageForm) {
        if (!!modelForm) {
            const _modelData = value as IImageData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IImageDto;
            this[imageData.guid] = _modelDto[imageDto.guid]!;
            this[imageData.fileName] = _modelDto[imageDto.fileName];
            this[imageData.extension] = _modelDto[imageDto.extension];
            this[imageData.description] = _modelDto[imageDto.description];
            this[imageData.contentType] = _modelDto[imageDto.contentType];
            this[imageData.folderShardPath] = _modelDto[imageDto.folderShardPath];
            this[imageData.height] = _modelDto[imageDto.height];
            this[imageData.width] = _modelDto[imageDto.width];
            this[imageData.modifiedOn] = _modelDto[imageDto.modifiedOn];
            this[imageData.inactive] = _modelDto[imageDto.inactive]!;
            this[imageData.deleted] = _modelDto[imageDto.deleted]!;
            this[imageData.fileVariantType] = _modelDto[imageDto.fileVariantType_Name];
        }
    }
        
    static create(modelDto?: IImageDto | null): IImageData | null
    static create(modelData: IImageData, modelForm: IImageForm): IImageData | null
    static create(value?: IImageDto | IImageData | null, modelForm?: IImageForm): IImageData | null {

        if (!!modelForm) {
            const _modelData = value as IImageData;
            return new ImageData(_modelData, modelForm);
        } else {
            const _modelDto = value as IImageDto;
            return _modelDto ? new ImageData(_modelDto) : null;
        }
    }
}
